// removed by extract-text-webpack-plugin
module.exports = {"root":"Toolbox__root___3mecg","title":"Toolbox__title___1mi2e","row":"Toolbox__row___2D6Bn","colorPicker":"Toolbox__colorPicker___2yOw6","label":"Toolbox__label___2Iqa6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Toolbox/Toolbox.scss
// module id = 979
// module chunks = 0